import request from "helper/request";
import combineLink from "helper/combineLink";
import apiMiniSite from "helper/apiMiniSite";


class SearchMiniSiteService {
    searchFetch = async (query) => {

        let options = {
            setLoading: false,
            withLoader: false,
            query: {query}
        }

        return request.get(combineLink(apiMiniSite.productSearch), options)
    };
}

export const searchService = new SearchMiniSiteService();
